// This file can be replaced during build by using the `fileReplacements` array.
// `ng build ---prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

import { EnvironmentModel, AppConfigService, EnvironmentType } from 'common';

/*export const environmentConfigurationMap: EnvironmentModel[] = [
  {
    production: false,
    apiDomain: 'localhost:43782',
    appInsights: {
      instrumentationKey: '88f1eca6-295a-4e62-a5b8-9c92fd2a7507'
    },
    apiEndpoint: 'http://localhost:8001/',
    scope: 'so.api',
    spaUrl: 'http://localhost:4200',
    clientId: 'SO_SPA',
    disablePartyUsersManagement: false,
    environmentType: EnvironmentType.Development,
    identityProvider: {
      authorityUrl: 'http://localhost:43782/'
    },
    userManagement: true,
  },
  {
    production: true,
    apiDomain: 'so.ishareworks.org',
    appInsights: {
      instrumentationKey: '6744630d-cedd-43c1-ba8e-358ecb4fb9fc'
    },
    apiEndpoint: '/',
    scope: 'so.api',
    spaUrl: 'https://so.ishareworks.org',
    clientId: 'SO_SPA',
    disablePartyUsersManagement: true,
    environmentType: EnvironmentType.Live,
    identityProvider: {
      authorityUrl: 'https://so.ishareworks.org/'
    },
    userManagement: true,
  },
  {
    production: true,
    apiDomain: 'schemeowner-stagingschemeowner.azurewebsites.net',
    appInsights: {
      instrumentationKey: 'c3309beb-faec-4390-8238-7b528b526ce0'
    },
    apiEndpoint: '/',
    scope: 'so.api',
    spaUrl: 'https://schemeowner-stagingschemeowner.azurewebsites.net',
    clientId: 'SO_SPA',
    disablePartyUsersManagement: true,
    environmentType: EnvironmentType.Live,
    identityProvider: {
      authorityUrl: 'https://schemeowner-stagingschemeowner.azurewebsites.net/'
    },
    userManagement: true,
  },
  {
    production: false,
    apiDomain: 'ishare-so-live-qa.azurewebsites.net',
    appInsights: {
      instrumentationKey: '1a4e4df6-2bcb-423b-9539-51104b09c47b'
    },
    apiEndpoint: '/',
    scope: 'so.api',
    spaUrl: 'https://ishare-so-live-qa.azurewebsites.net',
    clientId: 'SO_SPA',
    disablePartyUsersManagement: true,
    environmentType: EnvironmentType.QALive,
    identityProvider: {
      authorityUrl: 'https://ishare-so-live-qa.azurewebsites.net/'
    },
    userManagement: true,
  },
  {
    production: false,
    apiDomain: 'ishare-qatest-schemeowner.azurewebsites.net/',
    appInsights: {
      instrumentationKey: '6d25ec47-77fa-488f-947c-365d74f23464'
    },
    apiEndpoint: '/',
    scope: 'so.api',
    spaUrl: 'https://ishare-qatest-schemeowner.azurewebsites.net/',
    clientId: 'SO_SPA',
    disablePartyUsersManagement: false,
    environmentType: EnvironmentType.QATest,
    identityProvider: {
      authorityUrl: 'https://ishare-qatest-schemeowner.azurewebsites.net//'
    },
    userManagement: true,
  },
  {
    production: true,
    apiDomain: 'scheme.isharetest.net',
    appInsights: {
      instrumentationKey: '1341bf56-5a99-4f77-9385-d2acbffe6e46'
    },
    apiEndpoint: '/',
    scope: 'so.api',
    spaUrl: 'https://scheme.isharetest.net',
    clientId: 'SO_SPA',
    disablePartyUsersManagement: false,
    environmentType: EnvironmentType.Test,
    identityProvider: {
      authorityUrl: 'https://scheme.isharetest.net/'
    },
    userManagement: true,
  }
];*/
export const environment = {
  production: false,
  keycloakEndpoint: 'http://localhost:8080/auth',
};
/*export function environmentFactory() {
  const configService = new AppConfigService(environmentConfigurationMap, environmentConfigurationMap[0]);
  return configService.get();
}*/

/*
 * In development mode, to ignore zone related error stack frames such as
 * `zone.run`, `zoneDelegate.invokeTask` for easier debugging, you can
 * import the following file, but please comment it out in production mode
 * because it will have performance impact when throw error
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
